import { ThemeProvider, createTheme } from "@mui/material";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { EveWorldProvider } from "@eveworld/contexts";
import { ErrorNotice, ErrorNoticeTypes } from "@eveworld/ui-components";

import EntityView from "./components/EntityView";

import { App } from "./App";
import { MUDProvider } from "./MUDContext";
import SmartSUsProvider from "./src/contract/SmartSUsContext";
import { setup } from "./mud/setup";
import React from "react";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: "0px !important",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          letterSpacing: 0,
        },
        message: {
          padding: "8px 16px !important",
        },
      },
    },
  },
});

const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        path: "*",
        element: <EntityView />,
      },
    ],
  },
]);

setup().then(async (result) => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <ErrorBoundary
      fallback={
        <ErrorNotice
          type={ErrorNoticeTypes.MESSAGE}
          errorMessage="Anomaly detected: See developer console for details"
        />
      }
    >
      <EveWorldProvider>
        <SmartSUsProvider>
          <ThemeProvider theme={darkTheme}>
            <MUDProvider value={result}>
              <RouterProvider router={router} />
            </MUDProvider>
          </ThemeProvider>
        </SmartSUsProvider>
      </EveWorldProvider>
      ,
    </ErrorBoundary>
  );
});
